export default [
  {
    path: '',
    name: 'home',
    component: () => import('@/views/pages/dashboard/Innovation.vue'),
    meta: {
      pageTitle: 'Home',
      breadcrumb: [
        {
          text: 'Home',
          active: true,
        },
      ],
      resource: 'Home',
      action: 'read',
    },
  },
]
